const locationPathArr = [
    '/collections/mens-new-arrivals',
    '/collections/womens-new-arrivals',
    '/collections/kids-new-arrivals',
    '/collections/nike-new-arrivals',
    '/collections/adidas-new-arrivals',
    '/collections/jordan-new-arrivals'
]

const locationPath = window.location.pathname;
const locationSearch = window.location.search;
locationPathArr.forEach((pathname) => {
    if (locationPath === pathname && locationSearch === '?sort_by=published-descending' ) {
        window.location.search = '?sort=extra-sort1-descending';
    }
});
